import { formatDateMmDdYyyy } from '@src/utils';

/** The title burned into the video, or null when the burn carries none. */
const getBurnedTitle = (version) => {
  const title = version?.appliedConfig?.titleText?.trim();
  return title || null;
};

/**
 * `toLocaleDateString()` was the first attempt and it read differently for every viewer — a
 * pt-BR browser rendered 13/08/2026 where an en-US one rendered 8/13/2026. The site is English
 * throughout, and this shared helper is what the media table's own row already uses one line
 * above these, so the two dates now match.
 */
const formatBurnDate = (version) => {
  const created = version?.createdAt ? new Date(version.createdAt) : null;
  return created && !Number.isNaN(created.getTime()) ? formatDateMmDdYyyy(created) : null;
};

/**
 * How every version row in the media tab names itself: `<kind> · title · date`.
 *
 * The API's DTOs carry a fixed label per kind — every branding burn says `branded`, every caption
 * burn says `captioned` — so two burns of the same media would be indistinguishable in a list.
 * The burned title is what the user recognises, and the date breaks the remaining ties. Both
 * already travel in the DTO, so this costs no extra request.
 *
 * The kind always leads. These rows sit beside each other, so dropping the word when a title
 * exists would tell the user which burn it is while hiding what kind of burn it is.
 *
 * The title comes from `appliedConfig`, the snapshot taken at burn time — not from the preset,
 * which may have been renamed or deleted since. Both endpoints carry it under that name, so a
 * combined burn is named like a branding-only one; a caption-only burn has none and is named by
 * its date alone.
 */
export const withTitleAndDate = (kind, version) =>
  [kind, getBurnedTitle(version), formatBurnDate(version)].filter(Boolean).join(' · ');



// WEBPACK FOOTER //
// ./src/helpers/brandingVersionHelpers.js